export class ButtonSettings {
  constructor(overrides) {
    const defaults = {
      text: 'Button',
      font: {
        fontSize: 16,
        fontWeight: '400',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      onFocusBackgroundColor: '#ffffff',
      onUnfocusBackgroundColor: '#575757',
      onFocusTextColor: '#000000',
      onUnfocusTextColor: '#ffffff',
      languages: {},
      startFocus: false
    };
    Object.assign(this, defaults, overrides);
  }
}
export const ButtonTypes = {
  text: {
    text: {
      title: 'Text',
      type: 'InputLanguage'
    }
  },
  styles: {
    font: {
      title: 'Font',
      type: 'Font'
    },
    onFocusBackgroundColor: {
      title: 'On Focus Background Color',
      type: 'ColorPicker'
    },
    onUnfocusBackgroundColor: {
      title: 'On Unfocus Background Color',
      type: 'ColorPicker'
    },
    onFocusTextColor: {
      title: 'On Focus Text Color',
      type: 'ColorPicker'
    },
    onUnfocusTextColor: {
      title: 'On Unfocus Text Color',
      type: 'ColorPicker'
    }
  },
  settings: {
    startFocus: {
      title: 'First Focused Item',
      type: 'Switch'
    }
  }
};